import React from 'react'

import { ROUTING_MEASURES } from 'cube'
import { isNil } from 'ramda'

import { Link, Text } from '@driftt/dds'
import { CubeQueryStringAdapter } from '@driftt/dds.reports'

import { useTrackDrillDownClickEvent } from 'components/conversation/hooks/useTrackDrilldownClickEvent'
import { ReportKPICard } from 'components/KPICard'
import { useRoutingReportDrillDownQuery } from 'components/routing/RoutingReportDrillDown'
import { CONVO_DETAIL_REPORT_PATH } from 'layouts/ConversationsDetailReport/ConversationsDetailReport.constants'
import { getHumanizedDuration } from 'utils/format'

import { FIRST_RESPONSE_RANGE_DESCRIPTION } from './FirstResponse.constants'
import useFirstResponse from './useFirstResponse.hook'

export const FirstResponse = () => {
  const {
    score,
    metric,
    isLoading,
    isError,
    hasNoData,
    totalRecords,
    totalRequests,
  } = useFirstResponse()
  const { drillDownCubeQuery } = useRoutingReportDrillDownQuery(
    ROUTING_MEASURES.RESPONSE_COUNT
  )

  const { trackViewEvent } = useTrackDrillDownClickEvent(
    'RoutingFirstResponseChatsKPICard'
  )

  const drillDownQueryString =
    CubeQueryStringAdapter.toQueryString(drillDownCubeQuery)

  return (
    <ReportKPICard
      isLoading={isLoading}
      isError={isError}
      hasNoData={hasNoData}
      title="Time to first response"
      subtitle="What is the median time it takes for a teammate to first respond?"
      score={score}
      metric={metric}
      metricRange={FIRST_RESPONSE_RANGE_DESCRIPTION}
      formatMetric={(medianFirstResponse: number) =>
        getHumanizedDuration(medianFirstResponse, 'seconds')
      }
    >
      {!isNil(totalRequests) && !isNil(totalRecords) && (
        <Text variant="metadata">
          {totalRecords.toLocaleString()} out of{' '}
          {totalRequests.toLocaleString()} responded chats
        </Text>
      )}
      {!!totalRecords && (
        <Link
          target="_blank"
          variant="inline"
          href={`${CONVO_DETAIL_REPORT_PATH}?${drillDownQueryString}`}
          onClick={() => trackViewEvent({ totalRecords: totalRecords ?? 0 })}
        >
          View data
        </Link>
      )}
    </ReportKPICard>
  )
}
